export default "__VITE_ASSET__BSNiEVKC__"